var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-select-wrapper" },
    [
      _vm.label
        ? _c(
            "label",
            {
              staticClass: "c-select-label",
              class: _vm.labelClass,
              attrs: { for: _vm.id },
            },
            [_vm._v(" " + _vm._s(_vm.label) + " ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(_setup.vSelect, {
        attrs: {
          "aria-placeholder": "Select type",
          options: _vm.options,
          searchable: _vm.searchable,
          clearable: _vm.clearable,
          filterable: _vm.filterable,
          placeholder: _vm.placeholder,
          "dropdown-should-open": _setup.dropdownShouldOpen,
          loading: _vm.loading,
          reduce: _vm.modelTransform,
          selectable: _setup.isOptionSelectable,
          disabled: _vm.disabled,
          "append-to-body": _vm.appendToBody,
          "group-values": _vm.groupValues,
          "group-label": _vm.groupLabel,
        },
        on: {
          search: function ($event) {
            return _setup.emit("search", $event)
          },
          open: function ($event) {
            return _setup.emit("open")
          },
          close: function ($event) {
            return _setup.emit("close")
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "open-indicator",
              fn: function ({ attributes }) {
                return [
                  _c(
                    "span",
                    _vm._b({}, "span", attributes, false),
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: "fas fa-angle-down" },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "option",
              fn: function (option) {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center",
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(option.label) +
                          "\n                "
                      ),
                      option.deletable
                        ? _c(_setup.CButton, {
                            staticClass: "ml-2",
                            attrs: {
                              size: "icon",
                              icon: ["far", "trash-can"],
                              disabled: option.disabled,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _setup.emit("delete-option", option)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
            },
            _vm._l(_setup.slots, function (_, slotName) {
              return {
                key: slotName,
                fn: function (scope) {
                  return [_vm._t(slotName, null, null, scope)]
                },
              }
            }),
          ],
          null,
          true
        ),
        model: {
          value: _setup.model,
          callback: function ($$v) {
            _setup.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }